export const TEST_ID = 'organizationDetails';
